export interface TestimonialProps {
    name: string;
    point: string;
    description: string;
    numStars: number;
}

const Testimonial = ({ name, point, description, numStars }: TestimonialProps) => {
    return (
        <div className="testimonial-item">
            <h3>{name}</h3>
            <h4>{point}</h4>
            <div className="stars">
                {Array.from({ length: numStars }).map((_, i) => (
                    <i key={i} className="bi bi-star-fill"></i>
                ))}
            </div>
            <p>
                <i className="bi bi-quote quote-icon-left"></i>
                <span style={{ whiteSpace: 'pre-line' }}>{description}</span>
                <i className="bi bi-quote quote-icon-right"></i>
            </p>
        </div>
    );
};
export default Testimonial;
